import React from 'react'
import { PrimaryBtn, SecondaryBtn, OutlinedBtn } from './styles'
import { logEvent } from '../../Utils'
import { PLL_LINKS } from '../../Config/config'
import { Link } from 'react-router-dom'

type ActionButtonProps = {
  btnStyle: 'primary' | 'secondary' | 'outlined'
  location: string
}

// Button for sending to app push alerts //
export const GetAlertsBtn: React.FC<React.PropsWithChildren<ActionButtonProps>> = ({
  btnStyle,
  location,
  children,
}) => {
  let analytics = {
    event: 'get_alerts_click',
    params: { location: location, buttonText: 'Get Alerts' },
  }

  const handleButtonClick = () => {
    analytics && logEvent(analytics.event, analytics.params)
  }
  return (
    <>
      {btnStyle === 'primary' && (
        <Link to={PLL_LINKS.getAlertsAppLink}>
          <PrimaryBtn onClick={handleButtonClick} buttonType={btnStyle}>
            {children}
          </PrimaryBtn>
        </Link>
      )}
      {btnStyle === 'secondary' && (
        <SecondaryBtn onClick={handleButtonClick} buttonType={btnStyle}>
          <Link to={PLL_LINKS.getAlertsAppLink}>{children}</Link>
        </SecondaryBtn>
      )}
      {btnStyle === 'outlined' && (
        <Link to={PLL_LINKS.getAlertsAppLink}>
          <OutlinedBtn onClick={handleButtonClick} buttonType={btnStyle}>
            {children}
          </OutlinedBtn>
        </Link>
      )}
    </>
  )
}
